import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

declare var $: any;

@Component({
  selector: 'app-comman-header',
  templateUrl: './comman-header.component.html',
  styleUrls: ['./comman-header.component.css']
})
export class CommanHeaderComponent implements OnInit {
  username: string; FirmName: string; loginlist: any = [];
  DashBoardHref: string;

  constructor(private router: Router, private MsgService: ToastrService) { }

  ngOnInit() {
    this.GetSessionValue();
  }
  GetSessionValue() {
    try {
      if (sessionStorage.getItem('loginSession') != null) {

        // *************************************change 16012020 *****************************
        let ResponseDecrpt = sessionStorage.getItem('loginSession');
        this.loginlist = JSON.parse(window.atob(ResponseDecrpt));
        this.username = this.loginlist[0]['UserName'];
        this.FirmName = this.loginlist[0]['FullName'];

        if (this.loginlist[0]['UserLevelId'] == 2) {
          this.DashBoardHref = "/admin";
        }
        else if (this.loginlist[0]['UserLevelId'] == 3) {
          this.DashBoardHref = "/DA";
        }
        else if (this.loginlist[0]['UserLevelId'] == 4) {
          this.DashBoardHref = "/LDCRO";
        }
        else if (this.loginlist[0]['UserLevelId'] == 5) {
          this.DashBoardHref = "/DC";
        }
        else if (this.loginlist[0]['UserLevelId'] == 10) {
          this.DashBoardHref = "/bidder";
        }
        // ****************end*************************************************

      }
    }
    catch (err) {
      console.log(err);
    }
  }

  NavbarOpen() {
    if ($(".nav-side-menu").hasClass("navbaropen")) {
      $('.nav-side-menu').removeClass('navbaropen');
      $('.menu-close').removeClass('menu-close-in');
    }
    else {
      $('.nav-side-menu').addClass('navbaropen');
      $('.menu-close').addClass('menu-close-in');
    }
    return false;
  }
  logout() {
    sessionStorage.clear();
    this.MsgService.warning('Logout');
    this.router.navigate(['/']);
  }


}
